import React from 'react';
import PropTypes from 'prop-types';
import Swiper from 'react-id-swiper';

import Container from 'common/src/components/UI/Container';
import Fade from 'react-reveal/Fade';

import PartnerSectionWrapper, {
  AboutBox,
  FinalBlock,
  ApplyBlock
} from './buy.style';
import BImg1 from 'common/src/assets/image/hosting/laptop.jpg';
import BImg2 from 'common/src/assets/image/hosting/grad.jpg';
import BImg3 from 'common/src/assets/image/hosting/banking.jpg';
import BImg4 from 'common/src/assets/image/hosting/money.jpg';

import { thinLeft } from 'react-icons-kit/entypo/thinLeft';
import { Icon } from 'react-icons-kit';

import 'swiper/css/swiper.css';

const settings = {
  autoplay: {
    delay: 3000,
    disableOnInteraction: false
  },
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  }
};

const PartnerSection = () => {
  return (
    <>
      <PartnerSectionWrapper>
        <Container>
          <Fade bottom cascade>
            <AboutBox>
              <div className="title">Get Started in 4 Easy Steps</div>
              <div className="title-sub">
                Join the fastest growing Cloud Platform for Infrastructure
                Services
              </div>

              <div className="over-box">
                <Swiper {...settings}>
                  <div className="swipe-content">
                    <div className="img">
                      <img src={BImg1}></img>
                    </div>

                    <div className="text-content">
                      <div>
                        <ul>
                          <li className="active">
                            <Icon
                              icon={thinLeft}
                              size={18}
                              className="eq-width"
                            />{' '}
                            01 Create Account
                          </li>
                          <li>
                            <Icon
                              icon={thinLeft}
                              size={18}
                              className="eq-width"
                            />{' '}
                            02 Undergo Flipserve Associate Program
                          </li>
                          <li>
                            <Icon
                              icon={thinLeft}
                              size={18}
                              className="eq-width"
                            />{' '}
                            03 Connect Bank Information
                          </li>
                          <li>
                            <Icon
                              icon={thinLeft}
                              size={18}
                              className="eq-width"
                            />{' '}
                            04 Provide Services & Start Earning
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="swipe-content">
                    <div className="img">
                      <img src={BImg2}></img>
                    </div>
                    <div className="text-content">
                      <div>
                        <ul>
                          <li>
                            <Icon
                              icon={thinLeft}
                              size={18}
                              className="eq-width"
                            />{' '}
                            01 Create Account
                          </li>
                          <li className="active">
                            <Icon
                              icon={thinLeft}
                              size={18}
                              className="eq-width"
                            />{' '}
                            02 Undergo Flipserve Associate Program
                          </li>
                          <li>
                            <Icon
                              icon={thinLeft}
                              size={18}
                              className="eq-width"
                            />{' '}
                            03 Connect Bank Information
                          </li>
                          <li>
                            <Icon
                              icon={thinLeft}
                              size={18}
                              className="eq-width"
                            />{' '}
                            04 Provide Services & Start Earning
                          </li>
                        </ul>
                      </div>
                    </div>{' '}
                  </div>
                  <div className="swipe-content">
                    <div className="img">
                      <img src={BImg3}></img>
                    </div>
                    <div className="text-content">
                      <div>
                        <ul>
                          <li>
                            <Icon
                              icon={thinLeft}
                              size={18}
                              className="eq-width"
                            />{' '}
                            01 Create Account
                          </li>
                          <li>
                            <Icon
                              icon={thinLeft}
                              size={18}
                              className="eq-width"
                            />{' '}
                            02 Undergo Flipserve Associate Program
                          </li>
                          <li className="active">
                            <Icon
                              icon={thinLeft}
                              size={18}
                              className="eq-width"
                            />{' '}
                            03 Connect Bank Information
                          </li>
                          <li>
                            <Icon
                              icon={thinLeft}
                              size={18}
                              className="eq-width"
                            />{' '}
                            04 Provide Services & Start Earning
                          </li>
                        </ul>
                      </div>
                    </div>{' '}
                  </div>
                  <div className="swipe-content">
                    <div className="img">
                      <img src={BImg4}></img>
                    </div>
                    <div className="text-content">
                      <div>
                        <ul>
                          <li>
                            <Icon
                              icon={thinLeft}
                              size={18}
                              className="eq-width"
                            />{' '}
                            01 Create Account
                          </li>
                          <li>
                            <Icon
                              icon={thinLeft}
                              size={18}
                              className="eq-width"
                            />{' '}
                            02 Undergo Flipserve Associate Program
                          </li>
                          <li>
                            <Icon
                              icon={thinLeft}
                              size={18}
                              className="eq-width"
                            />{' '}
                            03 Connect Bank Information
                          </li>
                          <li className="active">
                            <Icon
                              icon={thinLeft}
                              size={18}
                              className="eq-width"
                            />{' '}
                            04 Provide Services & Start Earning
                          </li>
                        </ul>
                      </div>
                    </div>{' '}
                  </div>
                </Swiper>
              </div>
            </AboutBox>
          </Fade>
        </Container>

        {/* <Container>
          <Fade bottom delay={30}>
            <ApplyBlock>
              <div className="title">Apply for Global Citizenship</div>
              <div className="btn">
                <button
                  onClick={() => {
                    window.location.href = '/global-citizen';
                  }}
                >
                  Apply
                </button>
              </div>
            </ApplyBlock>
          </Fade>
        </Container> */}
        {/*}
        <Container>
          <Fade bottom delay={30}>
            <FinalBlock>
              <div className="title">Explore Packages Pricing Options</div>
              <div className="btn">
                <button
                  onClick={() => {
                    window.location.href = '/pricing';
                  }}
                >
                  Review Plans
                </button>
              </div>
            </FinalBlock>
          </Fade>
        </Container>
        */}
      </PartnerSectionWrapper>
    </>
  );
};

export default PartnerSection;
